<template>
  <li class="border-gray-400 flex flex-row mb-2">
    <div :title="vendedor.Frentista" class="select-none cursor-pointer bg-gray-50 rounded-md flex flex-1 items-center py-4 px-2  transition duration-500 ease-in-out transform hover:-translate-y-1 hover:shadow-lg">
      <!-- <div class="flex flex-col rounded-md w-10 h-10 bg-gray-300 justify-center items-center mr-4">💧</div> -->
      <div class="flex-1 pl-1 ">
        <div class="font-medium">{{ abreviar(vendedor.Frentista) }}</div>
      </div>
      <div class="text-gray-600 text-sm">R$ {{ format(vendedor.Total) }}</div>
    </div>
  </li>
</template>

<script>
import { format } from '@/Utils/money'
export default {
  name: 'VendedorRankItem',
  props: {
    rank: Number,
    vendedor: Object,
  },
  computed: {
    cssRank(){
      if(this.rank == 1){
        return {
          'bg-orange-400': true,
        }
      }
      if(this.rank == 2){
        return {
          'bg-gray-500': true,
        }
      }

      return {
        'bg-orange-800': true,
      }
    },
  },
  methods:{
    format,

    abreviar(str) {
      const [nome, ...sobrenomes] = str.split(' ')

      const abreviaturas = sobrenomes.reduce((arr, str) => {
        const letraGrande = str.match(/[A-ZÖÄÅÀÁÂÃÌÍÒÓÉÊÚ]/)
        if (!letraGrande) return arr
        return arr.concat(`${letraGrande[0]}.`)
      }, [])

      return [nome, ...abreviaturas].join(' ')
    },
  },
}
</script>

<style>

</style>
